/** A single enum to define the opaque render orders of several objects that appear in walk mode. */
export enum WalkModeRenderOrders {
  /** Manual blurring preview rectangles */
  ManualBlurPreview = 100,

  /** Bounding boxes for points of interests used by AI responses */
  AiBoundingBoxes = 101,

  /** Outlines of the AI findings, drawn over their filled area */
  AiBoundingBoxOutlines = 102,
}
